export default {"src":"/_next/static/media/reservation_confirmed.ea63eafe.svg","height":41,"width":40,"blurWidth":0,"blurHeight":0};